import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api'
import type { Product } from '../types'
import { CardSkeleton, ProductCard } from '../components/ProductCard'

export function Home() {
  const [items, setItems] = useState<Product[] | null>(null)
  useEffect(() => { api.products({ badge: 'new', limit: '8' }).then(r => setItems(r.products)).catch(() => setItems([])) }, [])
  const promo = () => { void api.promoClick('fall-ensemble-event') }
  return (
    <>
      <section className="hero">
        <img src="/img/hero.jpg" alt="" fetchPriority="high" />
        <div className="copy container">
          <div className="eyebrow">Fall Ensemble Event</div>
          <h1>Up to 30% off the pieces that go together.</h1>
          <p>Linen, merino, denim that breaks in — the whole wardrobe, on sale through Sunday.</p>
          <div className="cta">
            <Link to="/sale" className="btn light" data-testid="hero-cta" onClick={promo}>Shop the event</Link>
            <Link to="/new" className="btn ghost" style={{ color: '#fff', borderColor: 'rgba(255,255,255,.6)' }}>New arrivals</Link>
          </div>
        </div>
      </section>
      <div className="promo-strip"><b>Use code FALL30</b> at checkout for 30% off sale styles. <Link to="/sale" onClick={promo}>Shop now</Link></div>

      <section className="section container">
        <div className="section-head"><h2>Shop by department</h2></div>
        <div className="tiles">
          <Link to="/women" className="tile"><img src="/img/tile-women.jpg" alt="" loading="lazy" /><span>Women</span></Link>
          <Link to="/men" className="tile"><img src="/img/tile-men.jpg" alt="" loading="lazy" /><span>Men</span></Link>
          <Link to="/sale" className="tile"><img src="/img/tile-sale.jpg" alt="" loading="lazy" /><span>Sale</span></Link>
        </div>
      </section>

      <section className="section container" style={{ paddingTop: 0 }}>
        <div className="section-head"><h2>New arrivals</h2><Link to="/new" className="more">View all</Link></div>
        <div className="grid">
          {items ? items.map(p => <ProductCard key={p.id} p={p} />) : Array.from({ length: 8 }).map((_, i) => <CardSkeleton key={i} />)}
        </div>
      </section>

      <section className="section container" style={{ paddingTop: 0 }}>
        <div className="editorial">
          <img src="/img/editorial.jpg" alt="Terracotta shirt dress" loading="lazy" />
          <div className="text">
            <div className="eyebrow" style={{ fontSize: 12, letterSpacing: '.18em', textTransform: 'uppercase', color: 'var(--muted)', marginBottom: 10 }}>Complete the ensemble</div>
            <h2>One dress. Three weekends.</h2>
            <p>Our Poplin Shirt Dress with the Classic Denim Jacket and a Ribbed Tank underneath — the outfit our stylists reach for first.</p>
            <Link to="/product/w-shirt-dress" className="btn" style={{ marginTop: 8 }}>Shop the look</Link>
          </div>
        </div>
      </section>
    </>
  )
}
